import { Component, computed, inject, Signal, ChangeDetectionStrategy } from '@angular/core';

import { TranslatePipe } from '@core/i18n-legacy';
import { TellentGroupKind, TellentMember, TellentMemberManagedBy } from '@core/tellent-types';
import {
  AvatarComponent,
  BoxComponent,
  ButtonComponent,
  DialogBodyComponent,
  DividerComponent,
  EmptyStateComponent,
  HeadingComponent,
  IconComponent,
  RtTooltip,
  TruncateComponent,
} from '@core/user-interface-legacy';

import { EditMemberGroupsTabController, GROUP_KIND } from './edit-member-group-tab.controller';
import { EditMemberGroupsTabService } from './edit-member-group-tab.service';

@Component({
  selector: 'edit-member-groups-tab',
  imports: [
    AvatarComponent,
    BoxComponent,
    ButtonComponent,
    DividerComponent,
    EmptyStateComponent,
    HeadingComponent,
    IconComponent,
    TranslatePipe,
    TruncateComponent,
    DialogBodyComponent,
    RtTooltip,
  ],
  templateUrl: './edit-member-groups-tab.component.html',
  styleUrl: './edit-member-groups-tab.component.less',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: EditMemberGroupsTabComponent.NgInputs,
  changeDetection: ChangeDetectionStrategy.Eager,
  viewProviders: [
    EditMemberGroupsTabService,
    EditMemberGroupsTabController,
    {
      provide: GROUP_KIND,
      useValue: TellentGroupKind.Group,
    },
  ],
})
export class EditMemberGroupsTabComponent {
  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
  public static NgInputs = ['memberGuid' as const];
  protected readonly vm = inject(EditMemberGroupsTabController);
  protected readonly TellentMemberManagedBy = TellentMemberManagedBy;
  protected memberGuid: string;

  protected memberData: Signal<TellentMember | null>;
  protected groups = computed(() =>
    this.memberData()?.teams.filter(team => team.kind === TellentGroupKind.Group),
  );
  protected noGroups = computed(() => {
    const groups = this.groups();
    return groups && groups.length === 0;
  });
  protected sortedGroups = computed(() => {
    const groups = this.groups();
    return groups ? [...groups].sort((a, b) => b.assignedAt.localeCompare(a.assignedAt)) : [];
  });

  protected ngOnInit() {
    this.memberData = this.vm.memberData(this.memberGuid);
  }
}
